"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StackView = _interopRequireDefault(require("../StackView"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _RenderActivityIndicator = _interopRequireDefault(require("./RenderActivityIndicator"));
var _shared = require("./shared");
var _sharedProptypes = require("./sharedProptypes");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const recursiveMap = (nodeChildren, fn) => _react.default.Children.map(nodeChildren, child => {
  if (! /*#__PURE__*/_react.default.isValidElement(child)) return child;
  if (child.props?.children) {
    return fn(/*#__PURE__*/_react.default.cloneElement(child, {
      children: recursiveMap(child.props.children, fn)
    }));
  }
  return fn(child);
});
const OverlayIndicator = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    variantProps,
    label,
    labelPosition,
    labelMapping,
    children,
    inline,
    showLabel,
    isActive = true
  } = _ref;
  const safeChildren = _Platform.default.OS === 'web' && isActive ? recursiveMap(children, c => /*#__PURE__*/_react.default.isValidElement(c) ? /*#__PURE__*/_react.default.cloneElement(c, {
    role: 'presentation'
  }) : c) : children;

  // inline + children
  if (inline && children) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: [staticStyles.container, _Platform.default.OS === 'web' && staticStyles.inlineContainer],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        style: staticStyles.backdropContainer,
        children: safeChildren
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        style: staticStyles.buttonOverlaySpinner,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RenderActivityIndicator.default, {
          ...variantProps,
          ref: ref,
          label: label
        })
      })]
    });
  }

  // overlay
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
    style: staticStyles.container,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: staticStyles.backdropContainer,
      children: safeChildren
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: [staticStyles.overlayContainer, _Platform.default.OS === 'web' && staticStyles.webOverlayContainer],
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StackView.default, {
        space: showLabel ? _shared.SPACE_WITH_LABEL : _shared.SPACE_WITHOUT_LABEL,
        tokens: {
          alignItems: 'center'
        },
        direction: labelMapping[labelPosition],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RenderActivityIndicator.default, {
          ...variantProps,
          ref: ref,
          label: label
        }), showLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          children: label
        })]
      })
    })]
  });
});
OverlayIndicator.displayName = 'OverlayIndicator';
const staticStyles = _StyleSheet.default.create({
  container: {
    position: 'relative'
  },
  inlineContainer: {
    display: 'inline-flex'
  },
  backdropContainer: {
    opacity: _shared.BACKDROP_OPACITY
  },
  overlayContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    ..._Platform.default.select({
      ios: {
        zIndex: _shared.BACKDROP_Z_INDEX
      },
      android: {
        elevation: 5
      }
    })
  },
  webOverlayContainer: {
    transform: [{
      translateX: '-50%'
    }, {
      translateY: '-50%'
    }],
    zIndex: _shared.BACKDROP_Z_INDEX
  },
  buttonOverlaySpinner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    ..._Platform.default.select({
      web: {
        transform: 'translate(-50%, -50%)',
        zIndex: _shared.BACKDROP_Z_INDEX
      },
      default: {
        transform: [{
          translateX: -0.5
        }, {
          translateY: -0.5
        }],
        zIndex: _shared.BACKDROP_Z_INDEX
      }
    })
  }
});
OverlayIndicator.propTypes = {
  /**
   * Shared props
   * */
  ..._sharedProptypes.activityIndicatorCommonProps,
  /**
   * Background color for overlay
   * */
  inline: _propTypes.default.bool,
  /**
   * Children on which the overlay is drawn
   * */
  children: _propTypes.default.node,
  /**
   * Controls whether the overlay is active and should apply the presentation role
   * */
  isActive: _propTypes.default.bool
};
var _default = exports.default = OverlayIndicator;